import { gameCatalog, type GameId } from "../shared/catalog";

const STORAGE_KEY = "flarecade.guest-scores.v1";

type GuestScores = Partial<Record<GameId, number>>;
const gameIds = new Set<string>(gameCatalog.map((game) => game.id));

function readScores(): GuestScores {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed: unknown = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) return {};

    const scores: GuestScores = {};
    for (const [key, value] of Object.entries(parsed)) {
      if (gameIds.has(key) && typeof value === "number" && Number.isFinite(value) && value >= 0) {
        scores[key as GameId] = Math.min(Math.floor(value), 999_999_999);
      }
    }
    return scores;
  } catch {
    return {};
  }
}

export function getBestScore(gameId: GameId): number {
  return readScores()[gameId] ?? 0;
}

export function saveBestScore(gameId: GameId, score: number): number {
  const safeScore = Number.isFinite(score)
    ? Math.max(0, Math.min(Math.floor(score), 999_999_999))
    : 0;
  const scores = readScores();
  const best = Math.max(scores[gameId] ?? 0, safeScore);
  scores[gameId] = best;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(scores));
  } catch {
    // Private browsing or storage policy can disable persistence; gameplay still works.
  }
  return best;
}
